export default {"src":"/_next/static/media/reddit.0de49278.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};